<template>
  <div class="receipt-component">
    <div class="receipt-item-component">
      <div class="key">هزینه ارسال ( تومان )</div>
      <div class="value" v-if="shippmentPrice" @click="shippmentPrice = 0">{{ Commafy(shippmentPrice) }}</div>
      <!-- <div v-else> -->
      <div v-else>
        <form @submit.prevent="calcTotalPrice">
          <input class="text-left" dir="ltr" type="text" v-model="shippmentPriceInput" ref="shippment" @blur="calcTotalPrice" />
        </form>
      </div>
    </div>

    <div class="receipt-item-component">
      <div class="key">تخفیف کل ( تومان )</div>
      <div class="value">
        {{ Commafy(discount) }}
      </div>
    </div>

    <div class="receipt-item-component">
      <div class="key">مالیات کل ( تومان )</div>
      <div class="value">
        {{ isFormal ? Commafy(tax) : 0 }}
      </div>
    </div>

    <div class="receipt-item-component">
      <div class="key">مبلغ قابل پرداخت ( تومان )</div>
      <div class="totalPrice">
        {{ Commafy(totalPayed)  }}
      </div>
    </div>
  </div>
</template>

<script>
import { invoiceMixins } from '../../../utils/mixins'
export default {
  name: 'receipt-component',
  mixins: [invoiceMixins],
  data() {
    return {
      tax: 0,
      totalPrice: 0,
      totalPriceWithShipping: 0,
      shippmentPrice: 0,
      discount: 0,
      val: 0,
      shippmentPriceInput: 0,
      totalPayed: 0
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.setDefaultValues()
    }
  },
  computed: {
    _invoiceDefaults() {
      return this.invoiceDefaults
    },
    formal(){
      return this.isFormal
    }
  },
  methods: {
    calcReceipt(list) {
      if(list){

        var _discountArray = []
        let _discount = 0
        var _taxArray = []
        let _tax = 0
        var _totalPriceArray = []
        let _totalPrice = 0
        // for bezan tax va discount haro joda kon beriz to array haye joda
        list.map(listItem => {
          _discountArray.push(listItem.items.find(item => item.fieldName == 'Discount'))
          _taxArray.push(listItem.items.find(item => item.fieldName == "TotalTaxCost"))
          _totalPriceArray.push(listItem.items.find(item => item.fieldName == "TotalPriceAfterDiscountAndTax"))
        })
        // ro arraye discount for bezan value haro jam kon ui neshun bede
        for (let i = 0; i < _discountArray.length; i++) {
          _discount += Number(_discountArray[i].value)
        }
        this.discount = _discount
        // ro arraye taxd for bezan value haro jam kon ui neshun bede
        for (let j = 0; j < _taxArray.length; j++) {
          _tax += Number(_taxArray[j].value)
        }
        this.tax = _tax
        for (let z = 0; z < _totalPriceArray.length; z++) {
          _totalPrice += Number(_totalPriceArray[z].value)
        }
        this.totalPrice = _totalPrice + Number(this.shippmentPriceInput)
        this.totalPayed = _totalPrice + Number(this.shippmentPriceInput)
      }
    },
    calcTotalPrice() {
        this.shippmentPrice = this.shippmentPriceInput
        this.shippmentPrice = this.shippmentPrice.split(',').join('')
        this.totalPayed = Number(this.totalPrice) + Number(this.shippmentPrice)
    },
    setDefaultValues(data) {
      if (data) {
        this.shippmentPrice = data.shippingCost
        this.shippmentPriceInput = data.shippingCost.toLocaleString()
        this.tax = data.totalTaxCost
        this.discount = data.totalDiscount
        this.totalPrice = data.totalPriceAfterDiscountAndTax
        this.totalPayed = data.totalPriceAfterDiscountAndTaxAndShippingCost
        
      }
    },
  },
  watch: {
    invoiceList(list) {
      this.calcReceipt(list)
    },
    formal(val){
      
      this.calcReceipt(this.invoiceList)
    },
    _invoiceDefaults(val) {
      this.setDefaultValues(val)
    },
    shippmentPrice(val) {
      this.$emit('shippmentPrice', Number(val))
    },
    shippmentPriceInput(val) {
      val = val.replace(/[^\d]/g, '').trim()
      if (val.length > 0) {
        val = Number(val).toLocaleString()
      }
      this.shippmentPriceInput = val
    },
  },
}
</script>

<style scoped lang="scss">
.receipt-component {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 15px 20px;
  height: 100%;
  input {
    border: 1px solid rgba(85, 110, 230, 1);
    outline: none;
    width: 96px;
    font-size: 14px;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
.receipt-item-component {
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 0px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  .key,
  .value {
    color: #555555;
  }
  .totalPrice {
    font-weight: 700;
    color: #556ee6;
  }
}
</style>
